export const ACCESS_TOKEN = 'accessToken';
export const CURRENT_USER = 'currentUser';
export const SYNC_TIME = 'syncTime';
export const IS_SNAPSHOT = 'isSnapshot';
export const CONTRACTS = 'contracts';
export const CONTACTS = 'contacts';
export const CONTACTS_AND_CONTRACTS = 'contactsAndContracts';
